import { useEffect } from "react";
import { withTranslation } from "react-i18next";

const SMARTSUPP_KEY = "a5d7bd346b82eae02255289800f6f6f3b4bd05b2";

function getCookieDomainForHost(hostname) {
    // Permet la continuité entre landingzone.fr <-> studio.landingzone.fr
    if (hostname === "landingzone.fr" || hostname.endsWith(".landingzone.fr")) return ".landingzone.fr";
    if (hostname === "landingzone.app" || hostname.endsWith(".landingzone.app")) return ".landingzone.app";
    return null;
}

function ensureSmartsuppInjected() {
    if (typeof window === "undefined" || typeof document === "undefined") return;

    // Init config globale
    window._smartsupp = window._smartsupp || {};
    window._smartsupp.key = SMARTSUPP_KEY;

    // Optionnel mais recommandé si vous avez des sous-domaines
    const cd = getCookieDomainForHost(window.location.hostname);
    if (cd) window._smartsupp.cookieDomain = cd;

    // Crée le stub "smartsupp(...)" qui queue les appels (comme le snippet officiel)
    if (!window.smartsupp) {
        window.smartsupp = function () {
            window.smartsupp._.push(arguments);
        };
        window.smartsupp._ = [];
    }

    // Injecte loader.js une seule fois
    if (!document.querySelector('script[data-smartsupp="loader"]')) {
        const s = document.createElement("script");
        s.type = "text/javascript";
        s.charset = "utf-8";
        s.async = true;
        s.src = "https://www.smartsuppchat.com/loader.js?";
        s.setAttribute("data-smartsupp", "loader");

        // proche du snippet: insérer avant le 1er <script> si possible
        const firstScript = document.getElementsByTagName("script")[0];
        if (firstScript?.parentNode) firstScript.parentNode.insertBefore(s, firstScript);
        else document.head.appendChild(s);
    }
}

function pushVisitorIdentity({ user, language }) {
    if (typeof window === "undefined") return;
    if (typeof window.smartsupp !== "function") return;

    const isFr = (language || "").startsWith("fr");

    if (user) {
        const fullName = `${user.firstname ?? ""} ${user.lastname ?? ""}`.trim();

        // Basic visitor data (doc officielle)
        if (fullName) window.smartsupp("name", fullName);
        if (user.email) window.smartsupp("email", user.email);
        if (user.phone) window.smartsupp("phone", user.phone);

        // Custom visitor data (doc officielle)
        window.smartsupp("variables", {
            language: isFr ? "fr" : "en",
            // Ajoutez vos champs internes si vous en avez :
            // User_ID: String(user.id),
            // Plan: user.plan,
        });
    } else {
        // Pas de user connecté : vous pouvez quand même stocker la langue si vous voulez
        window.smartsupp("variables", {
            language: isFr ? "fr" : "en",
        });
    }
}

const SmartsuppChat = ({ user, i18n }) => {
    // 1) injection du widget (1 fois)
    useEffect(() => {
        ensureSmartsuppInjected();
    }, []);

    // 2) push des infos user à chaque changement
    useEffect(() => {
        ensureSmartsuppInjected(); // garantit que le stub existe
        pushVisitorIdentity({ user, language: i18n?.language });
    }, [user, i18n?.language]);

    return null;
};

export default withTranslation()(SmartsuppChat);
